import { ExampleAI } from "./ExampleAI";
import { BelligerentAndNumerous } from "./BelligerentAndNumerous";
import { SpaceInvaders } from "./SpaceInvaders";
import { EatNSeek } from "./EatNSeek";
import { StarFarmer } from "./StarFarmer";
import { DoesNothing } from "./DoesNothing";

export default [
  ExampleAI,
  BelligerentAndNumerous,
  DoesNothing,
  EatNSeek,
  SpaceInvaders,
  StarFarmer,
];